import React from 'react';
import PropTypes from 'prop-types'
import '../../QueuePage.scss'
import SummaryCountCard from '../SummaryCountCard';
import { SummaryIcons } from '../../icons/SummaryIcons';
import { SortTypes } from '../../enums/SortAndFilterTypes';
import { QueueTableTypes } from '../../enums/QueueTableTypes';

const UnassignedQueueSummary = ({ summary, onSortChanged }) => {
    const handleSortClick = (sort) => {
        onSortChanged(sort, false)
    }

    return (
        <div className='columns'>
            <div className='column is-3 is-offset-1'>
                <SummaryCountCard loading={!summary} textKey='QueuePage.SortTypes.AllUnassigned'
                    count={(summary || {}).allUnassigned} onClick={() => handleSortClick(SortTypes.READY_TO_ASSIGN)}
                    tableType={QueueTableTypes.UNASSIGNED} >
                    {SummaryIcons.ALL_UNASSIGNED} 
                </SummaryCountCard>
            </div>
            <div className='column is-3'>
                <SummaryCountCard loading={!summary} textKey='QueuePage.SortTypes.ReadyToBeAssigned'
                    count={(summary || {}).readyToBeAssigned} onClick={() => handleSortClick(SortTypes.READY_TO_ASSIGN)}
                    tableType={QueueTableTypes.UNASSIGNED}>
                    {SummaryIcons.READY_TO_BE_ASSIGNED} 
                </SummaryCountCard>
            </div>
        </div>
    )
}

UnassignedQueueSummary.propTypes = {
    summary: PropTypes.object,
    onSortChanged: PropTypes.func.isRequired
}

export default UnassignedQueueSummary